import { render, staticRenderFns } from "./AnalogSettingItemAddModal.vue?vue&type=template&id=497160dc&scoped=true&"
import script from "./AnalogSettingItemAddModal.vue?vue&type=script&lang=js&"
export * from "./AnalogSettingItemAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497160dc",
  null
  
)

export default component.exports